/* @ngInject */
function AnalyticsDataFrameGroupedDonutController (
  $rootScope,
  $scope,
  $state,
  $translate,
  $timeout,
  AnalyticsService,
  $attrs,
  $window,
  Utils
) {
  $scope.flags = {
    loading: true,
    empty: false,
    hasError: false,
    tooltipNamePosition: 'top'
  }

  $scope.donutItems = []

  $scope.dataFrameName = ''
  $scope.dataFrameTruncateName = ''
  $scope.dataFrameSlug = ''

  const api = {
    _insertParamsAndLoadData,
    _loadDataFrameData,
    _successGetResponse,
    _errorGetResponse,
    _finallyGetResponse,
    _getTooltipNamePosition
  }

  const slug = $state.params.slug || $scope.slug

  this.getApi = () => api

  activate()

  function activate () {
    $scope.dataFrameName = $translate.instant($scope.data.name)
    $scope.dataFrameTruncateName = Utils.truncateText($scope.dataFrameName, 64)

    $scope.dataFrameSlug = $scope.data.slug
  }

  $scope.$watchCollection('filterParams', api._insertParamsAndLoadData)

  $scope.loadDataFrameData = () => api._loadDataFrameData(slug, $scope.data.id)

  $translate.onReady(() => {
    const dataFrameBigCardDonutTitle = $translate.instant($scope.data.name)
    $scope.flags.tooltipNamePosition = api._getTooltipNamePosition(dataFrameBigCardDonutTitle)
  })

  function _insertParamsAndLoadData (newValues) {
    if (!newValues.filtersLoaded) return

    const { calendar: { start, end } } = newValues

    $scope.params = {
      ...$scope.params,
      ...newValues,
      start,
      end
    }

    api._loadDataFrameData(slug, $scope.data.id)
  }

  function _loadDataFrameData (paramSlug, dataFrameId) {
    $scope.flags.loading = true
    $scope.loadingDataFrames.groupedDonut = true

    $scope.flags.hasError = false

    AnalyticsService.getDataFrameDataFromId(paramSlug, dataFrameId, $scope.params)
      .then(api._successGetResponse)
      .catch(api._errorGetResponse)
      .finally(api._finallyGetResponse)
  }

  function _successGetResponse (response) {
    const {
      data: {
        result
      }
    } = response

    if (!result.length) {
      $scope.flags.empty = true
      $scope.donutItems = []
      return
    }

    $scope.donutItems = result
  }

  function _errorGetResponse (error) {
    $scope.flags.hasError = true
    $scope.flags.empty = false
    $scope.donutItems = []
    console.error(error)
  }

  function _finallyGetResponse () {
    $scope.flags.loading = false
    $scope.loadingDataFrames.groupedDonut = false
  }

  function _getTooltipNamePosition (name) {
    const minCharLength = 12

    return name.length <= minCharLength ? 'right' : 'top'
  }
}

export { AnalyticsDataFrameGroupedDonutController }
